import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "vehicle-details-header__top" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "vehicle-details-header__top--print-text" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "vehicle-details-header__top--download-text" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "vehicle-details-header__title-row" };
const _hoisted_8 = { class: "vehicle-details-header__plate" };
const _hoisted_9 = { class: "vehicle-details-header__wrapper" };
const _hoisted_10 = { class: "vehicle-details-header__wrapper--col" };
const _hoisted_11 = { class: "vehicle-info__make" };
const _hoisted_12 = { class: "vehicle-info--small" };
const _hoisted_13 = { class: "vehicle-info--small" };
const _hoisted_14 = { class: "vehicle-info__years" };
const _hoisted_15 = { class: "vehicle-details-header__specs-section" };
const _hoisted_16 = { class: "specs-grid" };
const _hoisted_17 = {
    key: 0,
    class: "spec-row"
};
const _hoisted_18 = { class: "spec-row__value" };
const _hoisted_19 = {
    key: 1,
    class: "spec-row"
};
const _hoisted_20 = { class: "spec-row__value" };
const _hoisted_21 = {
    key: 2,
    class: "spec-row"
};
const _hoisted_22 = { class: "spec-row__value" };
const _hoisted_23 = {
    key: 3,
    class: "spec-row"
};
const _hoisted_24 = { class: "spec-row__value" };
const _hoisted_25 = { class: "vehicle-details-header__specs-section" };
const _hoisted_26 = { class: "specs-grid" };
const _hoisted_27 = {
    key: 0,
    class: "spec-row"
};
const _hoisted_28 = { class: "spec-row__value" };
const _hoisted_29 = {
    key: 1,
    class: "spec-row"
};
const _hoisted_30 = { class: "spec-row__value" };
const _hoisted_31 = {
    key: 2,
    class: "spec-row"
};
const _hoisted_32 = { class: "spec-row__value" };
const _hoisted_33 = {
    key: 3,
    class: "spec-row"
};
const _hoisted_34 = { class: "spec-row__value" };
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useVehicleDetails } from '../../composables/useVehicleDetails';
import { useAssets } from '../../composables/useAssets';
import LicensePlateEditOverlay from './LicensePlateEditOverlay.vue';
import LicensePlateCard from './LicensePlateCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VehicleDetailsHeader',
    emits: ["vehicleChanged"],
    setup(__props, { emit: __emit }) {
        const { licencePlate, vehicleDetails } = useVehicleDetails();
        const { assetUrl } = useAssets();
        // Add emit
        const emit = __emit;
        // Reference to the overlay component
        const editOverlay = ref(null);
        // Sticky state
        const isSticky = ref(false);
        // Format year range
        const formatYearRange = () => {
            const details = vehicleDetails.value;
            if (!details)
                return '';
            const start = details.year_start;
            const end = details.year_end;
            if (start && end) {
                return `${start} - ${end}`;
            }
            else if (start) {
                return `${start} -`;
            }
            else if (end) {
                return `- ${end}`;
            }
            return '';
        };
        const currentDate = ref('');
        const currentTime = ref('');
        const showLicensePlate = computed(() => licencePlate.value !== '');
        const updateDateTime = () => {
            const now = new Date();
            currentDate.value = now.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            currentTime.value = now.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit'
            });
        };
        // Handle scroll for sticky behavior (desktop only)
        const handleScroll = () => {
            // Only apply sticky on desktop (min-width: 1100px)
            if (window.innerWidth >= 1100) {
                isSticky.value = window.scrollY > 0;
            }
            else {
                isSticky.value = false;
            }
        };
        // Handle ESC key to close overlay
        const handleEscKey = (e) => {
            if (e.key === 'Escape') {
                editOverlay.value?.closeOverlay();
            }
        };
        // Edit license plate function - opens overlay instead of navigating
        const editLicensePlate = () => {
            editOverlay.value?.open();
        };
        // Handle vehicle selection from overlay
        const handleVehicleSelected = (vehicle) => {
            // Emit the vehicle type ID to parent so it can refresh products
            if (vehicle.id) {
                emit('vehicleChanged', vehicle.id);
            }
        };
        onMounted(() => {
            updateDateTime();
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleScroll);
            window.addEventListener('keydown', handleEscKey);
        });
        onUnmounted(() => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
            window.removeEventListener('keydown', handleEscKey);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["vehicle-details-header", { 'is-sticky': isSticky.value }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("img", {
                                    src: _unref(assetUrl)('/images/trade-site/logo.svg'),
                                    alt: "Duckhams Logo"
                                }, null, 8, _hoisted_4),
                                _createElementVNode("div", null, "Recommended printed on " + _toDisplayString(currentDate.value) + " at " + _toDisplayString(currentTime.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("img", {
                                    src: _unref(assetUrl)('/images/trade-site/logo.svg'),
                                    alt: "Duckhams Logo"
                                }, null, 8, _hoisted_6),
                                _createElementVNode("div", null, "Recommended downloaded on " + _toDisplayString(currentDate.value) + " at " + _toDisplayString(currentTime.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(LicensePlateCard, {
                                        "licence-plate": _unref(licencePlate),
                                        onEdit: editLicensePlate
                                    }, null, 8, ["licence-plate"])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("h2", _hoisted_11, _toDisplayString(_unref(vehicleDetails)?.make_title), 1),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(vehicleDetails)?.model_title), 1),
                                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(vehicleDetails)?.type_title), 1),
                                        _createElementVNode("p", _hoisted_14, _toDisplayString(formatYearRange()), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            (showLicensePlate.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spec-row__label" }, "License plate", -1)),
                                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(licencePlate)), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(vehicleDetails)?.drive_type)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "spec-row__label" }, "Drive Type", -1)),
                                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(vehicleDetails).drive_type), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(vehicleDetails)?.fuel)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "spec-row__label" }, "Fuel", -1)),
                                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(vehicleDetails).fuel), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(vehicleDetails)?.engine_build)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "spec-row__label" }, "Engine build", -1)),
                                                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(vehicleDetails).engine_build), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            (_unref(vehicleDetails)?.cylinder_count)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "spec-row__label" }, "Cylinders", -1)),
                                                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(vehicleDetails).cylinder_count), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(vehicleDetails)?.valves_count)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "spec-row__label" }, "Valves per cylinder", -1)),
                                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(vehicleDetails).valves_count), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(vehicleDetails)?.displacement)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "spec-row__label" }, "Displacement", -1)),
                                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(vehicleDetails).displacement) + " cc", 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(vehicleDetails)?.horse_power || _unref(vehicleDetails)?.power_kw)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "spec-row__label" }, "Power rating", -1)),
                                                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "spec-row__dots" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(vehicleDetails).horse_power) + " hp / " + _toDisplayString(_unref(vehicleDetails).power_kw) + " kW ", 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ], 2),
                _createVNode(LicensePlateEditOverlay, {
                    ref_key: "editOverlay",
                    ref: editOverlay,
                    onVehicleSelected: handleVehicleSelected
                }, null, 512)
            ], 64));
        };
    }
});
